import React from "react";
import {
  Col,
  Row,
  Form,
  Checkbox,
  Button,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  Radio,
  Switch,
  Space,
} from "antd";
import { SendOutlined } from "@ant-design/icons";
import "./PartnerForm.css";
import GAText from "./GAText";

const { Option } = Select;

const Contactv2Form = ({
  isSubmitting = false,
  submitForm = () => {},
  form = undefined,
}) => {
  const onFinish = (values) => {
    submitForm(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Spin spinning={isSubmitting}>
      <Form
        className="partnerForm"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <Row className="mb-3" gutter={16}>
          <Col md={12}>
            <Form.Item
              label={
                <label
                  className="text-primary-purple"
                  style={{ fontSize: "1rem" }}
                >
                  First Name
                </label>
              }
              required
              rules={[
                { required: true, message: "Please enter your first name" },
              ]}
              name="firstName"
            >
              <Input type="text" placeholder="First Name" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item
              label={
                <label
                  className="text-primary-purple"
                  style={{ fontSize: "1rem" }}
                >
                  Last Name
                </label>
              }
              required
              rules={[
                { required: true, message: "Please enter your last name" },
              ]}
              name="lastName"
            >
              <Input type="text" placeholder="Last Name" />
            </Form.Item>
          </Col>
        </Row>

        <Row className="mb-3" gutter={16}>
          <Col md={24}>
            <Form.Item
              label={
                <label
                  className="text-primary-purple"
                  style={{ fontSize: "1rem" }}
                >
                  Email
                </label>
              }
              required
              rules={[
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
                {
                  required: true,
                  message: "Enter your email",
                },
              ]}
              name="email"
            >
              <Input type="email" placeholder="user@example.com" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="updates"
          // label="Sign up for news and updates"
          rules={[
            {
              required: false,
              message: "Please select to sign up for news and updates",
            },
          ]}
        >
          <Radio defaultChecked={false} disabled={false} className="text-primary-purple" style={{ fontSize: "1rem" }}>
            Sign up for news and updates
          </Radio>
        </Form.Item>

        <Row  className="mb-3" gutter={16}>
          <Col md={24}>
            <Form.Item
              label={
                <label
                  className="text-primary-purple"
                  style={{ fontSize: "1rem" }}
                >
                  Phone (+1)
                </label>
              }
              required
              rules={[
                {
                  pattern: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
                  message: "Please check the format of phone number",
                },
                {
                  required: true,
                  message: "Please input your phone number",
                },
              ]}
              name="phone"
            >
              <Input type="text" placeholder="555-555-5555" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="interest"
          label={
            <label
              className="text-primary-purple"
              style={{ fontSize: "1rem" }}
            >
            What Services are you interested in?
          </label>
          }
          rules={[
            {
              required: false,
              message: "Please select the service you're interested in",
            },
          ]}
        >
          <Radio.Group >
            <Space direction="vertical">
              <Radio value={'caregiver_need_help'}>I'm a family caregiver and I need help</Radio>
              <Radio value={'employee_benefits'}>Employee Benefits</Radio>
              <Radio value={'other'}>Other</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="heard"
          label={
            <label
              className="text-primary-purple"
              style={{ fontSize: "1rem" }}
            >
            How did you hear about us?
          </label>
          }
          rules={[
            {
              required: false,
              message: "Please select the service you're interested in",
            },
          ]}
        >
          <Select defaultValue=""  >
            <Option value="Referral from an acquaintance">
              Referral from an acquaintance
            </Option>
            <Option value="Social media advertisement">
              Social media advertisement
            </Option>
            <Option value="Company info sheet">
              Company info sheet
            </Option>
            <Option value="Other source">
              Other source
            </Option>
           </Select>
        </Form.Item>

        <Form.Item
          label={
            <label className="text-primary-purple" style={{ fontSize: "1rem" }}>
              Message
            </label>
          }
          rules={[
            { required: true, max: 300, message: "Maximum message length is 300 characters." },
          ]}
          name="message"
          className="mb-3"
        >
          <Input.TextArea rows={5} showCount maxLength={300} />
        </Form.Item>
        <div className="mt-6">
        <GAText></GAText>

        </div>
      </Form>
    </Spin>
  );
};

const Contactv2Modal = ({
  setting = {
    title: "Inquire About Partnership Opportunities",
    isModalVisible: false,
    calendlyLink: "",
  },
  isSubmitting = false,
  handleCancel = () => {},
  submitForm = (values) => {
    console.log(values);
  },
  form = undefined,
}) => {
  return (
    <Modal
      title={<h2>{setting.title}</h2>}
      visible={setting.isModalVisible}
      onCancel={handleCancel}
      width={"80%"}
      // style={{ top: 50 }}
      onOk={form && form.submit}
      footer={[
        <Button
          key="back"
          shape="round"
          onClick={handleCancel}
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          shape="round"
          icon={<SendOutlined />}
          // style={{
          //   borderColor: "#8159f5",
          //   color: "#8159f5",
          // }}
          loading={isSubmitting}
          disabled={isSubmitting}
          onClick={form && form.submit}
        >
          Submit
        </Button>,
      ]}
    >
      <Contactv2Form
        submitForm={submitForm}
        isSubmitting={isSubmitting}
        form={form}
      />
    </Modal>
  );
};

export { Contactv2Modal, Contactv2Form };
